import React, { useState } from 'react';
import {
  useGetAiringTodayTvQuery,
  useGetOnAirTvQuery,
  useGetTopRatedTvQuery,
  useGetTrendingQuery,
  useGetTvDetailsQuery,
  useGetTvPopularQuery,
} from '../../services/movieApi';
import { useParams } from 'react-router-dom';
import { SwiperSlide, Swiper } from 'swiper/react';
import TvCard from './TvCard';
import Select from 'react-select';
import Navbar from '../Navbar';
import HeroItem from '../MovieDetails/HeroItem';
import MovieTrailers from '../MovieDetails/MovieTrailers';
import MovieSimiliar from '../MovieDetails/MovieSimiliar';

const TvDetails = ({ trending, cardTv }) => {
  const { tvId } = useParams();
  const [mediaType, setMediaType] = useState('tv');
  const [timeType, setTimeType] = useState('day');

  const { data: detailTv } = useGetTvDetailsQuery({
    tvId: tvId === undefined ? '85425' : tvId,
  });

  const { data: trendingTv } = useGetTrendingQuery({
    mediaType,
    timeType,
  });

  const { data: popularTv } = useGetTvPopularQuery();
  const { data: topRatedTv } = useGetTopRatedTvQuery();
  const { data: airingTodayTv } = useGetAiringTodayTvQuery();
  const { data: onAirTv } = useGetOnAirTvQuery();

  const options = [
    {
      value: 'popularTv',
      label: 'Popular',
    },
    {
      value: 'topRatedTv',
      label: 'Top Rated',
    },
    {
      value: 'airingTodayTv',
      label: 'Airing Today',
    },
    {
      value: 'onAirTv',
      label: 'On Air Tv',
    },
  ];

  const [selectedOption, setSelectedOption] = useState(options[0]);

  return (
    <>
      {trending ? (
        <div className="flex flex-col container mx-auto px-5 md:px-6">
          <div className="flex flex-row items-center justify-between w-full py-8">
            <p className="text-sm md:text-xl font-bold">Trending TV</p>
            <div className="flex flex-row ring-1 ring-white rounded-2xl text-sm md:text-base">
              <button
                className={`my-1 ml-1 px-4 rounded-2xl md:px-6 md:py-2 lg:px-8 ${
                  timeType === 'day' ? 'bg-red-500' : ''
                }`}
                onClick={() => setTimeType('day')}
              >
                Day
              </button>
              <button
                className={`my-1 mr-1 px-4 rounded-2xl md:px-6 md:py-2 lg:px-8 ${
                  timeType === 'week' ? 'bg-red-500' : ''
                }`}
                onClick={() => setTimeType('week')}
              >
                Week
              </button>
            </div>
          </div>
          <div className="movie-list">
            <Swiper grabCursor={true} spaceBetween={10} slidesPerView={'auto'}>
              {trendingTv?.results.map((item, i) => (
                <SwiperSlide key={i}>
                  <TvCard item={item} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      ) : cardTv ? (
        <div className="flex flex-col container mx-auto px-5 md:px-6">
          <div className="flex flex-row items-center justify-between w-full py-8">
            <p className="text-sm md:text-xl font-bold">
              {selectedOption.value === 'popularTv'
                ? 'Popular TV Show'
                : selectedOption.value === 'topRatedTv'
                ? 'Top Rated TV Show'
                : selectedOption.value === 'airingTodayTv'
                ? 'Airing TV Today'
                : 'On Air TV Show'}
            </p>
            <Select
              defaultValue={options[0]}
              options={options}
              onChange={setSelectedOption}
              className="z-40 text-black"
            />
          </div>
          <div className="movie-list">
            <Swiper grabCursor={true} spaceBetween={10} slidesPerView={'auto'}>
              {selectedOption.value === 'popularTv' ? (
                <>
                  {popularTv?.results.map((item, i) => (
                    <SwiperSlide key={i}>
                      <TvCard item={item} />
                    </SwiperSlide>
                  ))}
                </>
              ) : selectedOption.value === 'topRatedTv' ? (
                <>
                  {topRatedTv?.results.map((item, i) => (
                    <SwiperSlide key={i}>
                      <TvCard item={item} />
                    </SwiperSlide>
                  ))}
                </>
              ) : selectedOption.value === 'airingTodayTv' ? (
                <>
                  {airingTodayTv.results?.map((item, i) => (
                    <SwiperSlide key={i}>
                      <TvCard item={item} />
                    </SwiperSlide>
                  ))}
                </>
              ) : (
                <>
                  {onAirTv?.results?.map((item, i) => (
                    <SwiperSlide key={i}>
                      <TvCard item={item} />
                    </SwiperSlide>
                  ))}
                </>
              )}
            </Swiper>
          </div>
        </div>
      ) : (
        <div className="bg-black text-white w-full h-full">
          <Navbar />
          <HeroItem items={detailTv} tvId={tvId} />
          <MovieTrailers tvId={tvId} />
          <MovieSimiliar tvId={tvId} />
        </div>
      )}
    </>
  );
};

export default TvDetails;
